// extracted by mini-css-extract-plugin
export var searchHeader = "_5u-0";
export var searchHeaderDark = "_5u-1";